import React from 'react'
import imagen1 from '../assets/imagen1.png'
import imagen2 from '../assets/imagen2.png'
import imagen3 from '../assets/imagen3.png'
import './Home.css'
export const Home = () => {
  return (
    <>
    <section className=''>
        <figure className='homeImages mb-2'>
            <img src={imagen1} alt="imagen" />
        </figure>
        <figure className='homeImages mb-2'>
        <img src={imagen2} alt="imagen" />
        </figure>
        <figure className='homeImages mb-2'>
        <img src={imagen3} alt="imagen" />
        </figure>
    </section>

    </>
  )
}
